import { Attachment } from '@/models/Attachment';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { AttachmentsState, AttachmentsTypes } from './types';

const INITIAL_STATE: AttachmentsState = {
    data: [] as Attachment[],
    loading: false,
    hasError: false,
    success: undefined,
};

const reducer: Reducer<AttachmentsState> = (state: AttachmentsState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case AttachmentsTypes.GET_ATTACHMENTS_REQUEST:
            return { ...state, loading: true, hasError: false };
        case AttachmentsTypes.GET_ATTACHMENTS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case AttachmentsTypes.GET_ATTACHMENTS_FAILURE:
            return { ...state, loading: false, hasError: true };
        case AttachmentsTypes.ATTACHMENTS_CLEAR:
            return INITIAL_STATE;
        case AttachmentsTypes.REMOVE_ATTACHMENT_REQUEST:
            return { ...state, loading: true, hasError: false, success: false };
        case AttachmentsTypes.REMOVE_ATTACHMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                success: true,
                data: state.data.filter((attachment: Attachment) => attachment.id !== action.payload),
            };
        case AttachmentsTypes.REMOVE_ATTACHMENT_FAILURE:
            return { ...state, loading: false, hasError: true, success: false };
        case AttachmentsTypes.PUT_ATTACHMENT_REQUEST:
            return { ...state, loading: true, hasError: false, success: false };
        case AttachmentsTypes.PUT_ATTACHMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: state.data.map((attachment) => {
                    if (attachment.id === action.payload.id) {
                        attachment.name = action.payload.name;
                    }
                    return attachment;
                }),
                success: true,
                hasError: false,
            };
        case AttachmentsTypes.PUT_ATTACHMENT_FAILURE:
            return { ...state, loading: false, hasError: true, success: false };
        case AttachmentsTypes.POST_ATTACHMENT_REQUEST:
            return { ...state, loading: true, hasError: false };
        case AttachmentsTypes.POST_ATTACHMENT_SUCCESS:
            return { ...state, loading: false, hasError: false, data: [...state.data, action.payload] };
        case AttachmentsTypes.POST_ATTACHMENT_FAILURE:
            return { ...state, loading: false, hasError: true };
        default:
            return state;
    }
};

export default reducer;
